import React from 'react';
import { Wordmark } from './Wordmark';
import { Monogram } from './Monogram';
export function Footer() {
  return <footer className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto pt-24 pb-16" data-id="element-32" data-mp="3ggaqfufcyb4x">
      <div className="flex flex-col items-center text-center pb-16 border-b border-ink/10" data-id="element-33" data-mp="32oe1u0cwejda">
        <Wordmark size="lg" align="center" data-id="element-34" data-mp="36p6aardy4k8i" />
        <p className="font-serif font-light text-ink/70 text-lg md:text-xl mt-6" data-id="element-35" data-mp="36pza18ehm9h5">
          Your Chief Executive of Health.
        </p>
        <div className="mt-8" data-id="element-36" data-mp="38qvoyiyxrr6">
          <Monogram className="text-xs" rule data-id="element-37" data-mp="38zbay6h7b62" />
        </div>
      </div>

      <div className="pt-10 flex justify-center" data-id="element-38" data-mp="3lec9wggp4cgx">
        <div className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-ink/40" data-id="element-39" data-mp="3ldkg9b6nsota">
          {'By application only · Limited roster · Est. 2025'}
        </div>
      </div>
    </footer>;
}